import { render, staticRenderFns } from "./TorontoCHMB41HQuiz4Question1.vue?vue&type=template&id=7112dc42&scoped=true&"
import script from "./TorontoCHMB41HQuiz4Question1.vue?vue&type=script&lang=ts&"
export * from "./TorontoCHMB41HQuiz4Question1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7112dc42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VForm,VImg,VRadio,VRadioGroup,VSimpleTable})
